<template>
  <div>
    <h4>License Details</h4>

    <div class="mb-3">
      <img
        :src="productDetails[license.upgraded_to || license.type].img"
        alt="Product logo"
      />

      <template
        v-if="
          user.trial_used &&
            ['free', 'trial'].includes(license.type) &&
            !license.upgraded_to
        "
      >
        <b-btn
          v-if="user.customer_type === 'commercial'"
          to="/quote"
          size="lg"
          block
          variant="primary"
        >
          Talk to Sales
        </b-btn>

        <b-btn
          v-else
          class="px-4"
          to="/licenses/add"
          size="lg"
          variant="orange"
          block
        >
          Upgrade Now
        </b-btn>
      </template>

      <template v-else-if="license.type === 'free'">
        <b-img
          class="rounded"
          src="/public/img/trial/activate.png"
          srcset="
            /static/img/trial/activate.png,
            /static/img/trial/activate@2x.png 2x,
            /static/img/trial/activate@3x.png 3x"
          style="cursor: pointer"
          @click="$store.dispatch('user/startTrial')"
        />
      </template>
    </div>

    <template v-if="!allLicenses.length">
      <p>
        Looks like you haven't purchased any licenses. Why not
        <b-link :to="{ name: 'Add License' }" gtm-info="home-purchased-add_one">
          add one
        </b-link>
        ?
      </p>
    </template>

    <p
      v-for="(status, key) in licenseStatus"
      :key="key"
      :class="{ 'mb-1': key != 'UNASSIGNED' }"
    >
      {{ status.count }}
      <span :class="status.class">{{ status.label }}</span>
      {{ status.count === 1 ? "license" : "licenses" }}
    </p>
    <b-link :to="{ name: 'Licenses' }" gtm-info="home-managed_licenses">
      <i class="icon-pencil"></i>
      Manage Licenses
    </b-link>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import productDetails from "@/data/products";

const licenseStatuses = {
  INUSE: {
    count: 0,
    label: "assigned",
    class: "text-success"
  },
  WAITING: {
    count: 0,
    label: "pending",
    class: "text-warning"
  },
  EXPIRED: {
    count: 0,
    label: "expired",
    class: "text-danger"
  },
  UNASSIGNED: {
    count: 0,
    label: "unassigned",
    class: "text-secondary"
  }
};

export default {
  data: () => ({
    productDetails
  }),

  computed: {
    ...mapGetters({
      license: "user/activeLicense"
    }),
    ...mapState("licenses", ["using", "owned"]),
    ...mapState(["user"]),

    allLicenses() {
      const combined = [].concat(this.using, this.owned);
      return combined.filter((license, i) => {
        // filter out duplicates where owned license is assigned to self
        return i === combined.findIndex(l => l.id === license.id);
      });
    },

    licenseStatus() {
      const statuses = JSON.parse(JSON.stringify(licenseStatuses));

      this.allLicenses.forEach(license => {
        if (license.type === "trial" && license.status === "EXPIRED") return;
        // increment the status counter for this license
        statuses[license.status].count++;
      });

      Object.keys(statuses).forEach(key => {
        if (statuses[key].count === 0) delete statuses[key];
      });

      return statuses;
    }
  }
};
</script>
